export { default as Thumb } from './Thumb';
